import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';
import { log } from '@/utils/core/vueLogger.js';
import { CacheManager } from '@/utils/core/cacheManager.js';

const kpiCache = new CacheManager('VueCache', 'cache', {
    maxAge: 24 * 60 * 60 * 1000,
    memoryCacheTTL: 30 * 60 * 1000,
    logCategory: 'KPI',
    keyPrefix: () => `${iframeDataBridge.getCustomer() ?? 'unknown'}.${iframeDataBridge.getCurrentUser()?.id ?? 'unknown'}.kpis.`,
});

export async function getSfaKPIs(forceRefresh = false) {
    if (!forceRefresh && !kpiCache.getFromMemory('sfaKPIs')) {
        try {
            const legacyData = await iframeDataBridge.getStorageAsync('SFA_KPIS');
            if (legacyData) {
                log('info', 'KPI', '📦 Seeding Vue cache from legacy storage (SFA_KPIS)');
                await kpiCache.put('sfaKPIs', legacyData);
                kpiCache.setInMemory('sfaKPIs', legacyData);
                return legacyData;
            }
        } catch (legacyError) {
            log('warn', 'KPI', `⚠️ Legacy storage check failed: ${legacyError.message}`);
        }
    }

    return kpiCache.fetchOrCache('sfaKPIs', fetchSfaKPIsFromAPI, { forceRefresh, fallback: [], backgroundRefresh: true });
}

export async function getSfaKPIsCustom(forceRefresh = false) {
    if (!forceRefresh && !kpiCache.getFromMemory('sfaKPIsCustom')) {
        try {
            const legacyData = await iframeDataBridge.getStorageAsync('SFA_KPIS_CUSTOM');
            if (legacyData) {
                log('info', 'KPI', '📦 Seeding Vue cache from legacy storage (SFA_KPIS_CUSTOM)');
                await kpiCache.put('sfaKPIsCustom', legacyData);
                kpiCache.setInMemory('sfaKPIsCustom', legacyData);
                return legacyData;
            }
        } catch (legacyError) {
            log('warn', 'KPI', `⚠️ Legacy storage check failed: ${legacyError.message}`);
        }
    }

    return kpiCache.fetchOrCache('sfaKPIsCustom', fetchSfaKPIsCustomFromAPI, { forceRefresh, fallback: [], backgroundRefresh: true });
}

async function fetchSfaKPIsFromAPI() {
    const response = await authenticatedFetch(getApiUrl('Sales/KPIs'), { method: 'GET' }, 'tokenSales');
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const sfaKPIs = await response.json();
    log('success', 'KPI', `✅ Fetched ${sfaKPIs.length} SFA KPIs`);
    return sfaKPIs;
}

async function fetchSfaKPIsCustomFromAPI() {
    const response = await authenticatedFetch(getApiUrl('Sales/KPIsCustom'), { method: 'GET' }, 'tokenSales');
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const sfaKPIsCustom = await response.json();
    log('success', 'KPI', `✅ Fetched ${sfaKPIsCustom.length} SFA KPIs custom`);
    return sfaKPIsCustom;
}

export async function refreshKPIs() {
    kpiCache.clearMemory();
    await kpiCache.clear();
}
